import api from './api';

export interface LocationPoint {
  lat: number;
  lng: number;
  updatedAt: string;
  address?: string;
}

export interface TrackedStaff {
  _id: string;
  name: string;
  role?: string;
  subRole?: string;
  phone?: string;
  email: string;
  isOnline?: boolean;
  isShopOpen?: boolean;
  lastSeen?: string;
  location: LocationPoint;
  currentJob?: {
    _id: string;
    location: string;
    status: string;
    date: string;
  } | null;
}

export interface TrackedVehicle {
  _id: string;
  make: string;
  model: string;
  licensePlate: string;
  status: string;
  type: string;
  location: LocationPoint;
  user?: string | {
    _id: string;
    name: string;
  };
}

export interface LiveData {
  staff: TrackedStaff[];
  vehicles: TrackedVehicle[];
  merchants: TrackedStaff[]; // Merchants share similar structure to Staff
  timestamp: string;
}

export const getLiveLocations = async () => {
  const response = await api.get('/tracking');
  return response.data;
};

export const updateMyLocation = async (lat: number, lng: number, address?: string, bookingId?: string) => {
  const response = await api.put('/tracking/user', { lat, lng, address, bookingId });
  return response.data;
};

export const updateOnlineStatus = async (isOnline: boolean) => {
  const response = await api.put('/users/online-status', { isOnline });
  return response.data;
};

export interface ETAResponse {
  provider: 'google' | 'osrm';
  durationSec: number;
  distanceMeters: number;
  textDuration: string;
  textDistance: string;
  arrivalTimeIso: string;
}

export const getETA = async (originLat: number, originLng: number, destLat: number, destLng: number) => {
  const params = new URLSearchParams({
    originLat: String(originLat),
    originLng: String(originLng),
    destLat: String(destLat),
    destLng: String(destLng),
  });
  const response = await api.get(`/tracking/eta?${params.toString()}`);
  return response.data as ETAResponse;
};
